//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

/**
 * QueryKeys must be unique
 *
 * An invalidation for a query with a duplicate queryKey will result
 * in an invalidation of all queries with the same key
 */
export const QueryKeyConstants = {
  // AccountSettings
  AccountSettings: 'account-settings',
  AccountSettingsAnalytics: 'account-settings-analytics',
  AccountSettingsAnalyticsAdobe: 'account-settings-analytics-adobe',
  AccountSettingsAnalyticsAdobeCompanies:
    'account-settings-analytics-adobe-companies',
  AccountSettingsAnalyticsAdobeOAuth: 'account-settings-analytics-adobe-oauth',
  AccountSettingsAnalyticsAdobeWebService:
    'account-settings-analytics-adobe-webservice',
  AccountSettingsAnalyticsGoogle: 'account-settings-analytics-google',
  AccountSettingsAnalyticsGoogleAnalytics4:
    'account-settings-analytics-google-analytics-4',
  AccountSettingsAnalyticsVibePixel: 'account-settings-analytics-vibe-pixel',
  AccountSettingsClientUsersList: 'account-settings-client-users-list',
  AccountSettingsCurrentUser: 'account-settings-current-user',
  AccountSettingsImpact: 'account-settings-impact',
  AccountSettingsImpactConnection: 'account-settings-impact-connection',
  AccountSettingsSocialInstagramAccountMessagesAccessStatus:
    'account-settings-social-instagram-account-messages-access-status',
  AccountSettingsProductFeedHealthOverview:
    'account-settings-product-feed-health-overview',
  AccountSettingsSocial: 'account-settings-social',
  AccountSettingsSocialInstagramAccount:
    'account-settings-social-instagram-account',
  AccountSettingsWalmart: 'account-settings-walmart',
  AccountSettingsWalmartOAuthUrl: 'account-settings-walmart-oauth-url',
  AccountSettingsYouTube: 'account-settings-youtube',
  AccountSettingsGetYouTubeConnectionStatus:
    'account-settings-get-youtube-connection-status',
  AccountSettingsGetYouTubeAuthorizationUrl:
    'account-settings-get-youtube-authorization-url',
  AccountSettingsSocialFacebook: 'account-settings-social-facebook',
  AccountSettingsSocialTikTokUser: 'account-settings-social-tiktok-user',
  AccountSettingsSocialPinterestUser: 'account-settings-social-pinterest-user',
  AccountSettingsSocialTwitter: 'account-settings-social-twitter',
  AccountSettingsSocialTwitterSettings:
    'account-settings-social-twitter-settings',
  AccountSettingsSocialTwitterUser: 'account-settings-social-twitter-user',
  AccountSettingsSocialYouTubeUser: 'account-settings-social-youtube-user',

  // AgentsDashboard
  AgentsDashboard: 'agents-dashboard',
  AgentsDashboardThreadMessages: 'agents-dashboard-thread-messages',
  AgentsDashboardThreadsHistory: 'agents-dashboard-threads-history',
  AgentsDashboardIntentMessages: 'agents-dashboard-intent-messages',
  AgentsDashboardMediaItems: 'agents-dashboard-media-items',

  // Campaigns
  Campaigns: 'campaigns',
  CampaignsContentAggregations: 'campaigns-content-aggregations',
  CampaignsContentLibrary: 'campaigns-content-library',
  CampaignsEstimatedRevenue: 'campaigns-estimated-revenue',
  CampaignsOnsiteRevenue: 'campaigns-onsite-galleries-revenue',
  CampaignsOnsiteReviewRevenue: 'campaigns-review-onsite-review-revenue',
  CampaignsSyndicatedReviewEstimatedRevenue:
    'campaigns-syndicated-review-estimated-revenue',

  // SAMPLING
  CampaignsSampling: 'campaigns-sampling',
  // Campaign Requests
  CampaignSamplingRequest: 'campaigns-sampling-request',
  CampaignSamplingRequestQuote: 'campaigns-sampling-request-quote',
  CampaignsSamplingProductBrands: 'campaigns-sampling-product-brands',
  CampaignsSamplingProductCategories: 'campaigns-sampling-product-categories',
  CampaignsSamplingOpportunities: 'campaigns-sampling-opportunities',
  CampaignsSamplingOpportunitiesSummary:
    'campaigns-sampling-opportunities-summary',
  CampaignsSamplingProductsCatalog: 'campaigns-sampling-products-catalog',
  CampaignsSamplingRequests: 'campaigns-sampling-requests',
  // Campaigns
  CampaignAnalyticsStats: 'campaign-analytics-stats',
  CampaignContentExportCsv: 'campaigns-content-export-csv',
  CampaignSamplingCertiniaTasks: 'campaign-sampling-certinia-tasks',
  CampaignSamplingFulfillment: 'campaign-sampling-fulfillment',
  CampaignSamplingMedia: 'campaign-sampling-media',
  CampaignSamplingPaymentIntent: 'campaign-sampling-payment-intent',
  CampaignSamplingQuotePaymentSummary:
    'campaign-sampling-quote-payment-summary',
  CampaignSamplingPostSurvey: 'campaign-sampling-post-survey',
  CampaignSamplingProductPdpUrl: 'campaign-sampling-product-pdp-url',
  CampaignSamplingProducts: 'campaign-sampling-products',
  CampaignSamplingReviewCompletionRate:
    'campaign-sampling-review-completion-rate',
  CampaignSamplingReviews: 'campaign-sampling-reviews',
  CampaignSamplingReviewsMedia: 'campaign-sampling-reviews-media',
  CampaignSamplingSyndicationDestinations:
    'campaign-sampling-syndication-destinations',
  CampaignSamplingSyndicationStats: 'campaign-sampling-syndication-stats',
  CampaignsSamplingGroup: 'campaigns-sampling-group',
  CampaignsSamplingGroupCampaigns: 'campaigns-sampling-group-campaigns',
  CampaignsSamplingGroupClientTasks: 'campaigns-sampling-group-client-tasks',
  CampaignsSamplingGroupExternalReviewCompletionRate:
    'campaigns-sampling-group-external-review-completion-rate',
  CampaignsSamplingGroupPostSurvey: 'campaigns-sampling-group-post-survey',
  CampaignsSamplingGroupPostSurveySummary:
    'campaigns-sampling-group-post-survey-summary',
  CampaignsSamplingGroupProducts: 'campaigns-sampling-group-products',
  CampaignsSamplingGroupReviews: 'campaigns-sampling-group-reviews',
  CampaignsSamplingGroupSyndicationDestinations:
    'campaigns-sampling-group-syndication-destinations',
  CampaignsSamplingGroupSyndicationProducts:
    'campaigns-sampling-group-syndication-products',
  CampaignsSamplingGroupTimelines: 'campaigns-sampling-group-timelines',
  CampaignsSamplingGroupSocialSyndicationStats:
    'campaigns-sampling-group-social-syndication-stats',
  CampaignsSamplingGroupsList: 'campaigns-sampling-groups-list',
  CampaignsSamplingList: 'campaigns-sampling-list',
  CampaignsSamplingListBvCampaignIds: 'campaigns-sampling-list-bv-campaign-ids',
  CampaignsSamplingMedia: 'campaigns-sampling-media',
  CampaignsSamplingContentDestinations:
    'campaigns-sampling-content-destinations',
  CampaignsSamplingRetailers: 'campaigns-sampling-retailers',
  CampaignsSamplingSocialMedia: 'campaigns-sampling-social-media',
  CampaignsVisitsStats: 'campaigns-visits-stats',
  // CREATORS
  CampaignsCreatorsCampaignsCount: 'campaigns-creators-campaigns-count',
  CampaignsCreatorsCampaignsRequest: 'campaigns-creators-campaigns-request',
  CampaignsCreatorsCampaignsRequestProducts:
    'campaigns-creators-campaigns-request-products',
  CampaignsCreatorsCampaignsRequests: 'campaigns-creators-campaigns-requests',
  CampaignsCreatorsCampaignsRequestValidation:
    'campaigns-creators-campaigns-request-validation',
  CampaignsCreatorsProposalDetails: 'campaigns-creators-proposal-details',
  CampaignsCreatorsProposalsList: 'campaigns-creators-proposals-list',
  CampaignsCreatorsProposalStatus: 'campaigns-creators-proposal-status',
  CampaignsCreatorsOrdersList: 'campaigns-creators-orders-list',
  CampaignsCreatorsOrderDetails: 'campaigns-creators-order-details',
  CampaignsCreatorsOrderEligibleProductsList:
    'campaigns-creators-order-eligible-products-list',
  CampaignsCreatorsBulkOrderEligibleProductsList:
    'campaigns-creators-bulk-order-eligible-products-list',
  CreatorsCampaignCuralateProductSearch:
    'campaigns-creators-curalate-product-search',
  CreatorsCampaigns: 'campaigns-creators',
  CreatorsCampaignsAddCreators: 'campaigns-creators-add-creators',
  CreatorsCampaignsAffiliateOrders: 'campaigns-affiliate-orders',
  CreatorsCampaignsAffiliatesAggregateStats:
    'campaigns-affiliates-aggregate-stats',
  CreatorsCampaignsAffiliatesGoogleAnalyticsConfiguration:
    'campaigns-creators-affiliates-ga-configuration',
  CreatorsCampaignsAffiliatesList: 'campaigns-affiliates-list',
  CreatorsCampaignsContents: 'campaigns-creators-campaigns-contents',
  CreatorsCampaignsContentsRemovedCount:
    'campaigns-creators-campaigns-contents-removed-count',
  CreatorsCampaignsContentApprovalMediaDownload:
    'creators-campaigns-content-approval-media-download',
  CreatorsCampaignsConversation: 'campaigns-creators-conversation',
  CreatorsCampaignsConversations: 'campaigns-creators-conversations',
  CreatorsCampaignsConversationsPreview:
    'campaigns-creators-conversations-preview',
  CreatorsCampaignsFailedMessagesCount:
    'campaigns-creators-failed-messages-count',
  CreatorsCampaignsFailedMessagesList:
    'campaigns-creators-failed-messages-list',
  CreatorsCampaignsCreatorPortalLink:
    'campaigns-creators-copy-creator-portal-link',
  CreatorsCampaignsContentApprovalContents:
    'campaigns-creators-content-approval-contents',
  CreatorsCampaignsContentApprovalCreatorsList:
    'campaigns-creators-content-approval-creators-list',
  CreatorsCampaignsContentApprovalLinkExport:
    'campaigns-creators-content-approval-link-export',
  CreatorsCampaignsContentApprovalLinkGet:
    'campaigns-creators-content-approval-link-get',
  CreatorsCampaignsInfluencersSearch: 'campaigns-creators-influencers-search',
  CreatorsCampaignsInformation: 'campaigns-creators-information',
  CreatorsCampaignsList: 'campaigns-creators-campaigns-list',
  CreatorsCampaignsMembersList: 'campaigns-creators-members-list',
  CreatorsCampaignsMetrics: 'campaigns-creators-campaigns-metrics',
  CreatorsCampaignsPayments: 'campaigns-creators-payments',
  CreatorsCampaignsPaymentsList: 'campaigns-creators-payments-list',
  CreatorsCampaignsPaymentsHistory: 'campaigns-creators-payments-history',
  CreatorsCampaignsPaymentsHistoryCSV:
    'campaigns-creators-payments-history-csv',
  CreatorsCampaignsPendingRetryTransactions:
    'campaigns-creators-pending-retry-transactions',
  CreatorsCampaignsPreviewToken: 'campaigns-creators-campaign-preview-token',
  CreatorsCampaignsProposalsDetailsCSV: 'campaigns-proposals-details-csv',
  CreatorsCampaignsReportAggregation:
    'campaigns-creators-campaigns-report-aggregation',
  CreatorsCampaignsSparkCodeData: 'campaigns-creators-sparkcode-data',
  CreatorsCampaignWorkflow: 'campaigns-creators-workflow',
  CreatorsCampaignWorkflowProducts: 'campaigns-creators-workflow-products',

  // Impact.com Integration
  CreatorsCampaignsImpact: 'campaigns-creators-impact',
  CreatorsCampaignsImpactPrograms: 'campaigns-creators-impact-programs',
  CreatorsCampaignsImpactProgramsSearch:
    'campaigns-creators-impact-programs-search',
  CreatorsCampaignsImpactPartnersSearch:
    'campaigns-creators-impact-partners-search',
  CreatorsCampaignsImpactDeals: 'campaigns-creators-impact-deals',
  CreatorsCampaignsImpactTerms: 'campaigns-creators-impact-terms',
  CreatorsCampaignsImpactWorkflow: 'campaigns-creators-impact-workflow',
  CreatorsCampaignsImpactPartnerMappings:
    'campaigns-creators-impact-partner-mappings',
  // Notes
  CreatorNotes: 'creator-notes',

  // Creator Community
  CreatorCommunity: 'creator-community',
  CreatorCommunityPreviewToken: 'creator-community-preview-token',
  CreatorCommunityApplications: 'creator-community-applications',
  CreatorCommunityApplicationsDetailsCSV:
    'creator-community-applications-details-csv',
  CreatorCommunityOverviewStatistics: 'creator-community-overview-statistics',
  CreatorCommunityConfiguration: 'creator-community-configuration',
  CreatorCommunityConfigurationPreview:
    'creator-community-configuration-preview',
  CreatorCommunityPreviewLink: 'creator-community-preview-link',

  // Content Source
  ContentSource: 'content-source',
  ContentSourceGetEligibleReviewsByProduct:
    'content-source-get-eligible-reviews-by-product',
  ContentSourceFindProducts: 'content-source-find-products',
  ContentSourceGetCartSummary: 'content-source-get-cart-summary',
  ContentSourceGetPopularProducts: 'content-source-get-popular-products',
  ContentSourceGetProductReviewMedia: 'content-source-get-product-review-media',

  // Content Supply Chain
  ContentSupplyChain: 'content-supply-chain',
  ContentSupplyChainDistribution: 'content-supply-chain-distribution',
  ContentSupplyChainDistributionGraphStats:
    'content-supply-chain-distribution-graph-stats',
  ContentSupplyChainDistributionSummaryStats:
    'content-supply-chain-distribution-summary-stats',
  ContentSupplyChainHasBazaarvoiceModerator:
    'content-supply-chain-has-bazaarvoice-moderator',
  ContentSupplyChainHasConnectStream: 'content-supply-chain-has-connect-stream',
  ContentSupplyChainModeration: 'content-supply-chain-moderation',
  ContentSupplyChainModerationBvCurated:
    'content-supply-chain-moderation-bv-curated',
  ContentSupplyChainModerationBvCuratedGraphStats:
    'content-supply-chain-moderation-bv-curated-graph-stats',
  ContentSupplyChainModerationBvCuratedRejectionReasons:
    'content-supply-chain-moderation-bv-curated-rejection-reasons',
  ContentSupplyChainModerationBvCuratedSummary:
    'content-supply-chain-moderation-bv-curated-summary',
  ContentSupplyChainModerationRightsRequests:
    'content-supply-chain-moderation-rights-requests',
  ContentSupplyChainModerationSummary:
    'content-supply-chain-moderation-summary',
  ContentSupplyChainSourcing: 'content-supply-chain-sourcing',
  ContentSupplyChainSourcingGraphStats:
    'content-supply-chain-sourcing-graph-stats',
  ContentSupplyChainSourcingSummary: 'content-supply-chain-sourcing-summary',
  ContentSupplyChainSummary: 'content-supply-chain-summary',

  // Email Settings
  EmailTemplateSettings: 'email-template-settings',
  NylasEmailConnections: 'nylas-email-connections',
  NylasEmailConnectionUrl: 'nylas-email-connection-url',

  // Payments
  Payments: 'payments',
  PaymentRecipientList: 'payment-recipient-list',
  PaymentsTransactionsAggregate: 'payments-transactions-aggregate',
  WalletAggregatedTransactions: 'wallet-aggregated-transactions',
  WalletTransactionsHistoryList: 'wallet-transactions-history-list',
  WalletTransactionsHistoryListCSV: 'wallet-transactions-history-list-csv',
  Wallets: 'wallets',

  // Media filters (Content Drawer and Media Library)
  MediaFilters: 'media-filters',
  MediaFiltersAutocompleteUsernamesHashtags:
    'media-filters-autocomplete-usernames-hashtags',
  MediaFiltersLabels: 'media-filters-labels',
  MediaFiltersLabelsManage: 'media-filters-labels-manage',
  MediaFiltersMediaItems: 'media-filters-media-items',
  MediaFiltersProducts: 'media-filters-products',
  MediaFiltersProductsDetails: 'media-filters-products-details',
  MediaFiltersReels: 'media-filters-reels',
  MediaFiltersAllUsers: 'media-filters-all-users',
  MediaFiltersVisualTagsSuggestions: 'media-filters-visual-tags-suggestions',

  // Creator Details
  CreatorDetails: 'creator-details',
  CreatorDetailsDetailedInfo: 'creator-details-detailed-info',
  CreatorDetailsAffableMedia: 'creator-details-affable-media',
  CreatorDetailsCostEstimates: 'creator-details-cost-estimates',
  CreatorDetailsInsights: 'creator-details-insights',
  CreatorDetailsInsightsAverageStoryEngagement:
    'creator-details-insights-average-story-engagement',
  CreatorDetailsInsightsBrandAffinity:
    'creator-details-insights-brand-affinity',
  CreatorDetailsInsightsBrandAffinityMedia:
    'creator-details-insights-brand-affinity-media',
  CreatorDetailsInsightsContentDistribution:
    'creator-details-insights-content-distribution',
  CreatorDetailsInsightsEngagementTimeline:
    'creator-details-insights-engagement-timeline',
  CreatorDetailsInsightsFollowerTimeline:
    'creator-details-insights-follower-timeline',
  CreatorDetailsInstagramAccountConnection:
    'creator-details-instagram-account-connection',
  CreatorDetailsLists: 'creator-details-lists',
  CreatorDetailsMedia: 'creator-details-media',
  CreatorDetailsIsProcessedMedia: 'creator-details-is-processed-media',
  CreatorDetailsRightsStatus: 'creator-details-rights-status',
  CreatorDetailsSimilarCreators: 'creator-details-similar-creators',
  CreatorDetailsSocialPlatforms: 'creator-details-social-platforms',
  CreatorDetailsUser: 'creator-details-user',
  CreatorDetailsMediaSafetyStats: 'creator-details-media-safety-stats',
  CreatorDetailsOnDemandBrandSafety: 'creator-details-on-demand-brand-safety',

  // Creator Lists
  CreatorLists: 'creator-lists',
  CreatorListsRights: 'creator-lists-rights',
  CreatorUsersList: 'creator-users-list',
  CreatorListsNetworkUsers: 'creator-lists-network-users',
  CreatorListsMedia: 'creator-lists-media',

  // Dropbox
  Dropbox: 'dropbox',
  DropboxScriptLoader: 'dropbox-load-script',

  // Harmony Ai
  HarmonyAi: 'harmony-ai',
  HarmonAiInfluencersSearch: 'harmony-ai-influencers-search',
  HarmonyAiFilter: 'harmony-ai-filter',
  HarmonyAiQuery: 'harmony-ai-query',
  HarmonyAiInfluencersSearch: 'harmony-ai-influencers-search',
  HarmonyAiSearchHistory: 'harmony-ai-search-history',
  HarmonyAiBrandsSearch: 'harmony-ai-brands-search',
  HarmonyAiLocationsSearch: 'harmony-ai-locations-search',

  // Hashtags Usage
  Hashtags: 'hashtags',
  HashtagsUsage: 'hashtags-usage',
  HashtagsUsageMultiHandle: 'hashtags-usage-multi-handle',

  // Inspiration
  Inspiration: 'inspiration',
  InspirationGetTikTokTrendingHashtags:
    'inspiration-get-tiktok-trending-hashtags',
  InspirationGetTikTokTrendingHashtagDetails:
    'inspiration-get-tiktok-trending-hashtag-details',
  InspirationGetTikTokTrendingHashtagsVideos:
    'inspiration-get-tiktok-trending-hashtags-videos',
  InspirationGetGenerativeAiTrendingHashtagExplanation:
    'inspiration-get-generative-ai-trending-hashtag-explanation',

  // Instagram
  Instagram: 'instagram',
  InstagramEngagement: 'instagram-engagement',
  InstagramEngagementLabels: 'instagram-engagement-labels',
  InstagramEngagementPosts: 'instagram-engagement-posts',
  InstagramEngagementPostsStats: 'instagram-engagement-posts-stats',
  InstagramStoryEngagement: 'instagram-story-engagement',
  InstagramStoryEngagementClips: 'instagram-story-engagement-clips',
  InstagramStoryEngagementGroups: 'instagram-story-engagement-groups',
  InstagramSummary: 'instagram-summary',
  InstagramSummaryDailyAudienceMetrics:
    'instagram-summary-daily-audience-metrics',
  InstagramSummaryWeeklyAudienceMetrics:
    'instagram-summary-weekly-audience-metrics',
  InstagramSummaryDateRange: 'instagram-summary-date-range',
  InstagramSummaryUserStats: 'instagram-summary-user-stats',
  InstagramSummaryRecentPosts: 'instagram-summary-recent-posts',
  InstagramSummaryTrafficStats: 'instagram-summary-traffic-stats',
  InstagramSummaryTopRecentEngagers: 'instagram-summary-top-recent-engagers',
  InstagramSummaryMentionedTaggedPosts:
    'instagram-summary-mentioned-tagged-posts',

  // Instagram Multi handle
  InstagramMultiHandleDefault: 'instagram-multi-handle-default',
  InstgramMultiHandleConnectedAccounts:
    'instgram-multi-handle-connected-accounts',

  // Like2Buy V2
  Like2BuyV2: 'like2buy-v2',
  Like2BuyV2Stores: 'like2buy-v2-stores',
  Like2BuyV2StoreIds: 'like2buy-v2-stores-ids',
  Like2BuyV2Store: 'like2buy-v2-store',
  Like2BuyV2PreviewUrl: 'like2buy-v2-preview-url',
  Like2BuyV2Items: 'like2buy-v2-items',
  Like2BuyV2PinnedItems: 'like2buy-v2-pinned-items',

  // Listening
  Listening: 'listening',
  ListeningAllTopics: 'listening-all-topics',
  ListeningCompetitor: 'listening-competitor',
  ListeningCompetitorGraphStats: 'listening-competitor-graph-stats',
  ListeningCompetitorInsights: 'listening-competitor-insights',
  ListeningCompetitorBubbleStats: 'listening-competitor-bubble-stats',
  ListeningCompetitorTopHashTags: 'listening-competitor-top-hashtags',
  ListeningGraphStats: 'listening-graph-stats',
  ListeningHashtag: 'listening-hashtag',
  ListeningHashtagMetadata: 'listening-hashtag-metadata',
  ListeningHashtagOverview: 'listening-hashtag-overview',
  ListeningInstagramAccountConnection: 'listening-instagram-account-connection',
  ListeningShareOfVoiceData: 'listening-share-of-voice-data',
  ListeningStats: 'listening-stats',
  ListeningTopHashTags: 'listening-top-hashtags',
  ListeningTopic: 'listening-topic',
  ListeningTopicGraphStats: 'listening-topic-graph-stats',
  ListeningTopicHashtagOverview: 'listening-topic-hashtag-overview',
  ListeningTopicStats: 'listening-topic-stats',
  ListeningTopicSummary: 'listening-topic-summary',
  ListeningTopicTopHashTags: 'listening-topic-top-hashtags',

  // Marketo
  MarketoIntegraion: 'marketo-integration',
  MarketoIntegrationScriptLoader: 'marketo-integration-script-loader',

  // Media Library
  MediaLibrary: 'media-library',
  MediaLibraryCollections: 'media-library-collections',
  MediaLibraryConnectCreators: 'media-library-connect-creators',
  MediaLibrarySettings: 'media-library-settings',
  MediaLibraryInstagram: 'media-library-instagram',
  MediaLibraryInstagramSettings: 'media-library-instagram-settings',
  MediaLibraryInstagramTrackedCompetitors:
    'media-library-instagram-tracked-competitors',
  MediaLibraryInstagramTrackedUsersAndHashtags:
    'media-library-instagram-tracked-users-and-hashtags',
  MediaLibraryMediaItems: 'media-library-media-items',
  MediaLibraryMediaItemsDeetsMetadata:
    'media-library-media-items-deets-metadata',
  MediaLibraryPinterestUser: 'media-library-pinterest-user',
  MediaLibraryTeamManagementUsers: 'media-library-team-management-users',
  MediaLibraryTikTok: 'media-library-tiktok',
  MediaLibraryTikTokSettings: 'media-library-tiktok-settings',

  // Meta Ads
  MetaAds: 'meta-ads',
  MetaAdsAggregatedInsights: 'meta-ads-aggregated-insights',
  MetaAdsInsightsItems: 'meta-ads-insights-items',

  // Rights Insights
  RightsInsights: 'rights-insights',
  RightsInsightsAggregatedStats: 'rights-insights-aggregated-stats',
  RightsInsightsGraphStats: 'rights-insights-graph-stats',
  RightsInsightsMessageStats: 'rights-insights-message-stats',

  // Scheduling
  Scheduling: 'scheduling',
  SchedulingGetFacebookLinkMetadata: 'scheduling-get-link-metadata',
  SchedulingGetPost: 'scheduling-get-post',
  SchedulingGetDraft: 'scheduling-get-draft',
  SchedulingGetDrafts: 'scheduling-get-drafts',
  SchedulingGetConnectionPosts: 'scheduling-get-connection-posts',
  SchedulingGetEligibleUsers: 'scheduling-get-eligible-users',
  SchedulingGetCurrentDefaults: 'scheduling-get-current-defaults',
  SchedulingGetTwitterUserSearch: 'scheduling-get-twitter-user-search',
  SchedulingGetDestinationUrlFromShortLink:
    'scheduling-get-destination-url-from-short-link',
  SchedulingGetShortLink: 'scheduling-get-short-link',
  SchedulingGetTrackingShortLink: 'scheduling-get-tracking-short-link',
  SchedulingInstagramLocationSearch: 'scheduling-instagram-location-search',
  SchedulingGetFacebookPageById: 'scheduling-get-facebook-page-by-id',
  SchedulingSearchFacebookPages: 'scheduling-search-facebook-pages',
  SchedulingGetFeedPreviewLiveInstagramPosts:
    'scheduling-get-feed-preview-live-instagram-posts',
  SchedulingGetFeedPreviewInstagramScheduledPosts:
    'scheduling-get-feed-preview-scheduled-instagram-posts',
  SchedulingGetPinterestUserBoards: 'scheduling-get-pinterest-user-boards',
  SchedulingGetInstagramRecommendedHashtags:
    'scheduling-instagram-recommended-hashtags',
  SchedulingGetRecommendedAiHashtags: 'scheduling-get-recommended-ai-hashtags',
  SchedulingGetInstagramShopsCatalogs:
    'scheduling-get-instagram-shops-catalogs',
  SchedulingGetInstagramShopsEligibility:
    'scheduling-get-instagram-shops-eligibility',
  SchedulingGetUpcomingScheduledPosts:
    'scheduling-get-upcoming-scheduled-posts',
  SchedulingUpsertDrafts: 'scheduling-upsert-draft-posts',
  SchedulingUpdateScheduledPostTime: 'scheduling-update-scheduled-post-time',
  SchedulingDeleteDrafts: 'scheduling-delete-draft-posts',
  SchedulingDeleteScheduledPosts: 'scheduling-delete-scheduled-posts',
  ScheduledingUpsertScheduledPosts: 'scheduling-upsert-scheduled-posts',
  SchedulingGetInstagramBestTimesToPost:
    'scheduling-get-instagram-best-times-to-post',
  SchedulingGetInstagramCollaborators: 'scheduling-get-instagram-collaborators',
  SchedulingGetTikTokBestTimesToPost:
    'scheduling-get-tiktok-best-times-to-post',
  SchedulingTikTok: 'scheduling-tiktok',
  SchedulingTikTokCommercialTrack: 'scheduling-tiktok-commercial-track',
  SchedulingTikTokCommercialTracks: 'scheduling-tiktok-commercial-tracks',
  SchedulingGetAugmentedSwipeUpLink: 'scheduling-get-augmented-swipe-up-link',
  SchedulingGetContextualShowroomLink:
    'scheduling-get-contextual-showroom-link',
  SchedulingGetShowroomShortLink: 'scheduling-get-showroom-short-link',
  SchedulingYouTube: 'scheduling-youtube',
  SchedulingGetYouTubePlaylists: 'scheduling-get-youtube-playlists',
  SchedulingGetYouTubeVideoCategories:
    'scheduling-get-youtube-video-categories',

  // Settings
  Settings: 'settings',
  SettingsGAStatus: 'setting-ga-status',
  SettingsAnalytics: 'settings-analytics',
  SettingsAnalyticsAttributionModel: 'settings-analytics-attribution-model',

  // Social Response
  SocialResponse: 'social-response',
  SocialResponseListViewDetails: 'social-response-list-view-details',
  SocialResponseGetPost: 'social-response-get-post',
  SocialResponseGetComments: 'social-response-get-comments',
  SocialResponseGetAllCommentsByPostId:
    'social-response-get-all-comments-by-post-id',
  SocialResponseGetDirectMessageConversation:
    'social-response-get-direct-message-conversation',
  SocialResponseFetchContentType: 'social-response-fetch-content-type',

  // Shopify
  Shopify: 'shopify',
  ShopifyStoreInfo: 'shopify-store-info',
  ShopifyPricingRules: 'shopify-pricing-rules',

  // Syndication Insights
  SyndicationInsights: 'syndication-insights',
  SyndicationInsightsModerationStats: 'syndication-insights-moderation-stats',
  SyndicationInsightsModerationStatsAggregate:
    'syndication-insights-moderation-stats-aggregate',
  SyndicationInsightsSharedMedia: 'syndication-insights-shared-media',
  SyndicationInsightsBazaarvoiceNetworkDestinations:
    'syndication-insights-bazaarvoice-network-destinations',

  // TikTok Ads Account
  TikTokAdsAccount: 'tiktok-ads-account',
  TikTokAdsAccountOauthURL: 'tiktok-ads-account-oauth-url',
  TikTokAdsAccountConnectionStatus: 'tiktok-ads-account-connection-status',

  // TikTok Mentioned
  TikTokMentioned: 'tiktok-mentioned',
  TikTokMentionedAutocomplete: 'tiktok-mentioned-autocomplete',
  TikTokMentionedContent: 'tiktok-mentioned-content',
  TikTokMentionedXlxsReport: 'tiktok-mentioned-xlxs-report',

  // Tracked Sources
  TrackedSources: 'tracked-sources',
  TrackedSourcesUsers: 'tracked-sources-users',
  TrackedSourcesUsersLimit: 'tracked-sources-users-limit',
  TrackedSourcesHashtags: 'tracked-sources-hashtags',

  // Universal Image Actions
  UniversalImageActions: 'universal-image-actions',
  UniversalImageActionsMetadata: 'universal-image-actions-media-item-metadata',
  UniversalImageActionsLabels: 'universal-image-actions-labels',
  UniversalImageActionsProducts: 'universal-image-actions-products',
  UniversalImageActionsProductsCrawledProducts:
    'universal-image-actions-products-crawled-products',
  UniversalImageActionsProductsList: 'universal-image-actions-products-list',
  UniversalImageActionsProductsProductCatalogs:
    'universal-image-actions-products-product-catalogs',
  UniversalImageActionsProductsProductCatalogClients:
    'universal-image-actions-products-product-catalog-clients',
  UniversalImageActionsProductsProductImage:
    'universal-image-actions-products-product-image',
  UniversalImageActionsProductsProductPdpUrl:
    'universal-image-actions-products-product-pdp-url',
  UniversalImageActionsProductsPublishers:
    'universal-image-actions-products-publishers',
  UniversalImageActionsProductsTaggedProducts:
    'universal-image-actions-products-tagged-products',
  UniversalImageActionsProductsTrackingParams:
    'universal-image-actions-products-tracking-params',
  UniversalImageActionsProductsTrackingParamsByVersion:
    'universal-image-actions-products-tracking-params-by-version',
  UniversalImageActionsProductsTrackingParamsCurrent:
    'universal-image-actions-products-tracking-params-current',
  UniversalImageActionsProductsTrackingUrlPreview:
    'universal-image-actions-products-tracking-url-preview',
  UniversalImageActionsProductsSearchRecentTrackingParamValues:
    'universal-image-actions-products-search-recent-tracking-param-values',
  UniversalImageActionsRights: 'universal-image-actions-rights',
  UniversalImageActionsRightsHistoricalUrls:
    'universal-image-actions-rights-historical-urls',
  UniversalImageActionsRightsCapabilities:
    'universal-image-actions-rights-capabilities',
  UniversalImageActionsRightsConfigurations:
    'universal-image-actions-rights-configurations',
  UniversalImageActionsRightsGenerativeAiRights:
    'universal-image-actions-rights-generative-ai-rights',
  UniversalImageActionsRightsSyndicatedStatus:
    'universal-image-actions-rights-syndicated-status',
  UniversalImageActionsRightsTermsAndConditionUrl:
    'universal-image-actions-rights-terms-and-condition-url',
  UniversalImageActionsRightsMessageLanguageDetection:
    'universal-image-actions-rights-message-language-detection',

  // Vibe Communities
  VibeCommunities: 'vibe-communities',
  VibeCommunitiesInviteLinks: 'vibe-communities-invite-links',
  VibeCommunitiesMembers: 'vibe-communities-members',
  VibeCommunitiesTags: 'vibe-communities-tags',

  // Welcome
  WelcomeScreen: 'welcome-screen',

  // YouTube
  YouTube: 'youtube',
  YouTubeAudience: 'youtube-audience',
  YouTubeEngagement: 'youtube-engagement',
  YouTubeVideos: 'youtube-videos',
  YouTubeUser: 'youtube-user',

  // Reporting
  Reporting: 'reporting',
  ReportingCommerce: 'reporting-commerce',
  ReportingCommerceBubbleStats: 'reporting-commerce-bubble-stats',
  ReportingCommerceGalleries: 'reporting-commerce-galleries',
  ReportingCommerceGalleriesCustom: 'reporting-commerce-galleries-custom',
  ReportingCommerceGraphStats: 'reporting-commerce-graph-stats',
  ReportingCommerceItemStats: 'reporting-commerce-item-stats',
  ReportingCommerceMetadata: 'reporting-commerce-metadata',
  ReportingCommerceTouchpointStats: 'reporting-commerce-touchpoint-stats',
  ReportingContentLibraryItems: 'reporting-content-library-items',
  ReportingFacebook: 'reporting-facebook',
  ReportingFacebookAudienceMetrics: 'reporting-facebook-audience-metrics',
  ReportingFacebookEngagementMetrics: 'reporting-facebook-engagement-metrics',
  ReportingInstagram: 'reporting-instagram',
  ReportingInstagramAudienceMetrics: 'reporting-instagram-audience-metrics',
  ReportingInstagramEngagementMetrics: 'reporting-instagram-engagement-metrics',
  ReportingInstagramUser: 'reporting-instagram-user',
  ReportingPinterest: 'reporting-pinterest',
  ReportingPinterestAudienceMetrics: 'reporting-pinterest-audience-metrics',
  ReportingPinterestConnectionStatus: 'reporting-pinterest-connection-status',
  ReportingPinterestDailyAudienceMetrics:
    'reporting-pinterest-daily-audience-metrics',
  ReportingPinterestEngagementMetrics: 'reporting-pinterest-engagement-metrics',
  ReportingTikTok: 'reporting-tiktok',
  ReportingTikTokAudienceMetrics: 'reporting-tiktok-audience-metrics',
  ReportingTikTokDailyAudienceMetrics:
    'reporting-tiktok-daily-audience-metrics',
  ReportingTikTokEngagementMetrics: 'reporting-tiktok-engagement-metrics',
  ReportingTwitter: 'reporting-twitter',
  ReportingTwitterAudienceMetrics: 'reporting-twitter-audience-metrics',
  ReportingTwitterDailyAudienceMetrics:
    'reporting-twitter-daily-audience-metrics',

  // CustomReporting
  CustomReporting: 'custom-reporting',
  CustomReportingReports: 'custom-reporting-reports',
  CustomReportingAiSummaries: 'custom-reporting-ai-summaries',
  CustomReportingSummaries: 'custom-reporting-summaries',
  CustomReportingReportInsertWidgets: 'custom-reporting-report-insert-widgets',
  CustomReportingReportUpdate: 'custom-reporting-report-update',
} as const;

export type QueryKeyConstants =
  (typeof QueryKeyConstants)[keyof typeof QueryKeyConstants];
